import type { ColDef } from 'ag-grid-community';
import { compareDesc, isSameDay } from 'date-fns';

import type { ISODateTime } from '@/types/date.ts';

type FilterDefinition = Pick<ColDef, 'filter' | 'filterParams'>;

const commonFilterParams = {
  buttons: ['apply', 'reset'],
  maxNumConditions: 1,
  closeOnApply: true,
  // debounceMs: 300, // debounceMs is ignored when apply button is present

  // date and numbers
  inRangeInclusive: true,
  includeBlanksInEquals: false,
  includeBlanksInGreaterThan: false,
  includeBlanksInLessThan: false,
  includeBlanksInRange: false,
};

export const textFilterDefinition: FilterDefinition = {
  filter: 'agTextColumnFilter',
  filterParams: {
    ...commonFilterParams,
    trimInput: true,
    filterOptions: ['contains'],
  },
};

export const dateFilterDefinition: FilterDefinition = {
  filter: 'agDateColumnFilter',
  filterParams: {
    ...commonFilterParams,
    filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange'],
    comparator: (filterLocalDateAtMidnight: Date, cellValue: ISODateTime) => {
      console.log({ filterLocalDateAtMidnight, cellValue });
      return isSameDay(filterLocalDateAtMidnight, cellValue) ? 0 : compareDesc(filterLocalDateAtMidnight, cellValue);
    },
  },
};

export const numberFilterDefinition: FilterDefinition = {
  filter: 'agNumberColumnFilter',
  filterParams: {
    ...commonFilterParams,
    filterOptions: ['greaterThanOrEqual', 'lessThanOrEqual', 'inRange'],
  },
};

export const setFilterDefinition: FilterDefinition = {
  filter: 'agSetColumnFilter',
  filterParams: {
    ...commonFilterParams,
    suppressMiniFilter: true,
    suppressSelectAll: true,
  },
};
